import { publicRoutes } from '@/shared/lib/public-routes';
import type { SupportedLocale } from '@/shared/localization';
import type { MenuItem } from '@ncai-axe/react-ui-v3';

export const getCommerceProductInfo = (locale: SupportedLocale) => ({
  name: 'Commerce' as const,
  url: publicRoutes.home({ locale }),
});

export const getIntroMenuLinks = (locale: SupportedLocale): MenuItem[] => [
  {
    name: {
      ko: '서비스 소개',
      en: 'Service',
    },
    url: publicRoutes.home({ locale }),
  },
  {
    name: {
      ko: '요금제',
      en: 'Pricing',
    },
    url: publicRoutes.pricing({ locale }),
  },
  {
    name: {
      ko: '블로그',
      en: 'Blog',
    },
    url: publicRoutes.blog({ locale }),
  },
];
